import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpClientService } from '../../Services/http-client.service';
import { SessionService } from '../../Services/session.service';
import { AppSettings } from '../../app-settings';
import { EventService } from "../../Services/event.service";

@Component({
  selector: 'app-purchases',
  templateUrl: './purchases.component.html',
  styleUrls: ['./purchases.component.css']
})
export class PurchasesComponent implements OnInit {
@ViewChild('iframe', { static: true }) iframe: ElementRef;
  tabPro:String = "tabPro";
  tabSec:String = "tabSec";
  tabActive:String ="tabSec";
  tableRowHover:boolean = false;
  extensionURL="https://e-gmat.com/blogs-activity/content/index.html";
  profileTabImg  = AppSettings.cdnUrl +"assets/images/purchase-cart.png";
  securityTabimg = AppSettings.cdnUrl+"assets/images/gmat-key.png";
  rotateIconImg = AppSettings.cdnUrl+"assets/images/purch_arrow.png";
  copyClipboard = AppSettings.cdnUrl+"assets/images/copy_key.png";
  loadingCircleURL = AppSettings.loadingCircleImageURL;
  dataLoaded:boolean = false;
  serverErrorFlagConcepts:boolean = false;
  serverErrorFlagNotes:boolean = false;
  coursesLength:number;
  coursePurchaseData = [];
  courseData = [{packageName:"Quant Online", enrollmentDate: "1517311731000", endDate: "1517311731000", status:"ENABLED",
				courses:[{courseName:"Quant Scholaranium", enrollmentDate: "1517311731", endDate: "1517311731", status:"ENABLED"},
				{courseName:"Distance", enrollmentDate: "1517311731", endDate: "1517311731", status:"ENABLED"},
				{courseName:"Algebra", enrollmentDate: "1517311731", endDate: "1517311731", status:"ENABLED"},
				{courseName:"Geometry", enrollmentDate: "1517311731", endDate: "1517311731", status:"ENABLED"}] },
				{packageName:"Verbal Online", enrollmentDate: "1517311731000", endDate: "1517311731000", status:"DISABLED",
				courses:[{courseName:"Quant Scholaranium", enrollmentDate: "1517311731", endDate: "1517311731", status:"ENABLED"},
				{courseName:"Distance", enrollmentDate: "1517311731", endDate: "1517311731", status:"ENABLED"},
				{courseName:"Algebra", enrollmentDate: "1517311731", endDate: "1517311731", status:"ENABLED"},
				{courseName:"Geometry", enrollmentDate: "1517311731", endDate: "1517311731", status:"ENABLED"}] }];
  testData = [{productName:"800Score & GMATClub Tests",orderNumber:1937, purchaseDate:"1517311731000",productKey:19370480}];
  testDataLength:number;
  testPurchaseData = [];
  externsionURLSecure:any=this.sanitizer.bypassSecurityTrustResourceUrl(this.extensionURL);
  userInfoSubscription:Subscription;
  userEmail:string;

  constructor(private httpClientService: HttpClientService , private sanitizer: DomSanitizer,private router:Router,private readonly location: Location , private sessionService: SessionService, private eventService: EventService) { }

  ngOnInit()
  {
  this.externsionURLSecure=this.sanitizer.bypassSecurityTrustResourceUrl(this.extensionURL);
  /*
 var frame = document.getElementById('extensionActivity') as HTMLIFrameElement;
    var doc = frame.contentWindow;
    let elem = doc.document.getElementsByClassName('overview-list__item');
  console.log('length is',elem.length);
  	 this.getCourseData();
  	 this.getTestData();*/
    this.getFullName();

  }



  getFullName()
  {

    this.userInfoSubscription = this.sessionService.getUserInfo$.
    subscribe(data => { if(data != "")
     this.userEmail = data.username;
     if(this.userEmail)
     {
        this.fireAccessedEvent();
     }
      });

   }

  fireAccessedEvent()
  {
    this.eventService.track('Accessed_User_Info', {"Accessed_Reason":"extensions"}, this.userEmail);
  }

  getCourseData()
  {
  	let data;
  	data = this.courseData;
  	this.coursesLength = data.length;
  	for(let i=0;i<this.coursesLength;i++)
  	{
  		let onePackage:any ={};
  		onePackage.packageName = data[i].packageName;
  		onePackage.enrollmentDate = data[i].enrollmentDate;
  		onePackage.endDate = data[i].endDate;
  		onePackage.status = data[i].status;
  		onePackage.rotateImage = false;
  	    onePackage.courses = [];
  		for(let j=0;j<data[i].courses.length;j++)
  		{
  			let oneCourse:any = {};
  			oneCourse.courseName = data[i].courses[j].courseName;
  			oneCourse.enrollmentDate = data[i].courses[j].enrollmentDate;
  			oneCourse.endDate = data[i].courses[j].endDate;
  			oneCourse.status = data[i].courses[j].status;
  			onePackage.courses.push(oneCourse);
  		}
  		this.coursePurchaseData.push(onePackage);
  	}
  	console.log(this.coursePurchaseData);
  }

  getTestData()
  {
  	let data;
  	data = this.testData;
  	this.testDataLength = data.length;
  	for(let i=0;i<this.testDataLength;i++)
  	{
  		let oneTest:any ={};
  		oneTest.productName = data[i].productName;
  		oneTest.orderNumber = data[i].orderNumber;
  		oneTest.purchaseDate = data[i].purchaseDate;
  		oneTest.productKey = data[i].productKey;
      oneTest.tooltipText = "Copy to clipboard";
  		this.testPurchaseData.push(oneTest);
  	}
  }

  copyKeyToClipboard(index)
  {
    let copyText = <HTMLInputElement>document.getElementById("testKeyText"+index);
    //debugger;
    copyText.select();
    this.testPurchaseData[index].tooltipText  = "Copied to clipboard";
    (<Document>document).execCommand("Copy", false, null);

  }

  outFunc(index)
  {
    this.testPurchaseData[index].tooltipText  = "Copy to clipboard";
  }

  tooglePackageList(index)
  {
  	this.coursePurchaseData[index].rotateImage = !this.coursePurchaseData[index].rotateImage;
  }

  toggle(tabName:String, vevent)
  {
  	this.tabActive = tabName;
  }

/*iframeLoaded(){
   //this.externsionURLSecure=this.sanitizer.bypassSecurityTrustResourceUrl(this.extensionURL);
  console.log('loaded2');
  let doc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
  let win=this.iframe.nativeElement.contentWindow;
  console.log(win);
   var element = doc.getElementsByClassName("overview-list__item");
   console.log('val:'+element.length);
  var frame = document.getElementById('extensionActivity') as HTMLIFrameElement;
    var doc = frame.contentWindow;
    let elem = doc.document.getElementsByClassName('block-list__list') as HTMLCollection;
    console.log(elem.length);
 var frame = document.getElementById('extensionActivity') as HTMLIFrameElement;
    var doc = frame.contentWindow;
    let elem = doc.document.getElementsByClassName('block-list__list') as HTMLCollection;
  console.log('length is'+elem);
}*/
extendCourse(){

console.log('extend');
 this.router.navigateByUrl('extendCourse');

}
}
